// Plan 4.1 — EventGuest types + relationship labels.
// Mirrors App Backend `src/schemas/eventGuest.schema.ts` and the
// service-layer `GuestRelationship` union.

export const EVENT_GUEST_RELATIONSHIPS = [
  'Grandmother',
  'Grandfather',
  'StepGrandparent',
  'Aunt',
  'Uncle',
  'Cousin',
  'FamilyFriend',
  'Godparent',
  'Neighbour',
  'Teacher',
  'Carer',
  'Other',
] as const;

export type EventGuestRelationship = (typeof EVENT_GUEST_RELATIONSHIPS)[number];

export const EVENT_GUEST_RELATIONSHIP_LABELS: Record<EventGuestRelationship, string> = {
  Grandmother: 'Grandmother',
  Grandfather: 'Grandfather',
  StepGrandparent: 'Step-Grandparent',
  Aunt: 'Aunt',
  Uncle: 'Uncle',
  Cousin: 'Cousin',
  FamilyFriend: 'Family Friend',
  Godparent: 'Godparent',
  Neighbour: 'Neighbour',
  Teacher: 'Teacher / Educator',
  Carer: 'Carer',
  Other: 'Other (specify)',
};

export interface EventGuest {
  id: string;
  familyId: string;
  firstName: string;
  lastName: string;
  phone: string | null;
  email: string | null;
  relationship: EventGuestRelationship;
  relationshipOther: string | null;
  // C7 — persistent per-guest dietary requirement.
  dietaryRequirements?: string | null;
  consentConfirmedAt: string;
  consentConfirmedByUserId: string;
  isRedacted: boolean;
  redactedAt: string | null;
  // Optional join from MyGuests list — last event this guest attended.
  lastUsedEventTitle?: string | null;
  lastUsedEventDate?: string | null;
}

/** Create-body shape sent to POST /families/:familyId/guests */
export interface CreateEventGuestRequest {
  firstName: string;
  lastName: string;
  phone?: string | null;
  email?: string | null;
  relationship: EventGuestRelationship;
  relationshipOther?: string | null;
  dietaryRequirements?: string | null;
  consentConfirmed: true;
}

/** Patch-body shape sent to PATCH /families/:familyId/guests/:guestId */
export interface UpdateEventGuestRequest {
  firstName?: string;
  lastName?: string;
  phone?: string | null;
  email?: string | null;
  relationship?: EventGuestRelationship;
  relationshipOther?: string | null;
  dietaryRequirements?: string | null;
}

/** Create-response shape from POST /families/:familyId/guests */
export interface CreateEventGuestResponse {
  guest: EventGuest;
  warning?: string;
  existingGuestId?: string;
}
